import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  getNextLanguage,
  normalizeLanguage,
  type AppLanguage,
} from "@/constants/i18n";

export function useLanguage() {
  const { i18n } = useTranslation();
  const lang = normalizeLanguage(i18n.resolvedLanguage ?? i18n.language);

  const setLanguage = useCallback(
    (next: AppLanguage) => {
      i18n.changeLanguage(next);
    },
    [i18n],
  );

  const toggleLanguage = useCallback(() => {
    i18n.changeLanguage(getNextLanguage(lang));
  }, [i18n, lang]);

  return { lang, setLanguage, toggleLanguage };
}
